export const METERS_PER_MILE = 1609;
export const KILOMETERS_PER_MILE = METERS_PER_MILE / 1000;
export const DISTANCE_UNIT = {
    kilometers: 'km',
    miles: 'mi',
};
